// 配置全局访问接口地址
// let commonUrl = "//h5test.ag-lotre.com";
let commonUrl = "https://zjp-gjkfyh.qpl-001.site";//
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl